import { mutate } from "../../defaults/fetch";
import { AUTH_TOKEN_NAME } from "../../defaults/utilities";



export const useLogin = () =>{
  
    const login = async (username,password)=>{
        const payload = {
            username,
            password
        }
        const url = `authenticate`;
        const data = await mutate(url,false,{...payload});
        return data;
    }

    return login;
}



export const useLogout = ()=>{
    const logout = ()=>{
        sessionStorage.removeItem(AUTH_TOKEN_NAME);
        return true;
    };
    return logout;
}